import styles from "./AdditionalTitle.module.scss";
import cn from "classnames";
import Icon from "@components/global/new/Icon/Icon";
import origArrow from "@assets/redesign/icons/drop.svg";
import ReactCardFlip from "react-card-flip";
import { useIntl } from "react-intl";
import { WLP202603 } from "../../../config";
import wlpArrow from "@components/WLP202603/assets/redesign/icons/drop.svg";

const arrow = WLP202603 ? wlpArrow : origArrow;

export interface IAdditionalTitle3Props {
  readonly show?: boolean;
  readonly className?: string;
  readonly rotate: boolean;

  onShow(): void;
}

const AdditionalTitle3 = (props: IAdditionalTitle3Props) => {
  const { formatMessage } = useIntl();
  return (
    <div className={cn(styles.wrapper, props.className)} onClick={props.onShow}>
      <ReactCardFlip flipDirection='vertical' isFlipped={props.rotate}>
        <p>
          {formatMessage({ id: "location.additional_title.available_racks" })}
        </p>
        <p>
          {formatMessage({
            id: "location.additional_title.available_equipment",
          })}
        </p>
      </ReactCardFlip>
      <Icon
        src={arrow}
        className={cn(styles.icon, {
          [styles.collapsed]: !props.show,
        })}
      />
    </div>
  );
};

export default AdditionalTitle3
